import noData from 'assets/images/noData.png';
import RichEditor from 'Components/RichEditor';
import Image from 'style-guide/Image';

const IntroductionView = ({ data }) =>
  data ? (
    <RichEditor content={data} editable={false} />
  ) : (
    <div className='d-flex justify-content-center mt--80'>
      <Image src={noData} />
    </div>
  );

export default IntroductionView;
